import { Enumify } from "enumify-ts";
class RelationshipType extends Enumify() {
    description;
    static CONTRACTOR = new RelationshipType("Contractor");
    static CARRIER = new RelationshipType("Carrier");
    static CUSTOMER = new RelationshipType("Customer");
    static _ = RelationshipType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return RelationshipType.values.map(r => {
            return {
                label: r.description,
                value: r.key
            };
        });
    }
    static filtersArray() {
        return RelationshipType.values.map(t => {
            return { text: t.description, value: t.key };
        });
    }
}
export default RelationshipType;
